import React, {useEffect, useState} from 'react'
import styled from 'styled-components';
import Modal from "../../common/Modal";
import {BooksitoutServer} from "../../config/BooksitoutServer";
import RatingStar from "../../common/RatingStar";
import RowSpacer from "../../common/styles/RowSpacer";
import toast from "react-hot-toast";
import BookResponse from "./BookResponse";
import BottomCTA from "../../common/button/BottomCTA";

interface Props {
    isModalOpen: boolean
    onClose: () => void
    updateRating: (rating: number) => void
    book: BookResponse
}

const BookRatingModal: React.FC<Props> = ({isModalOpen, onClose, updateRating, book}) => {
    const [rating, setRating] = useState<number>(1)
    const [hoverRating, setHoverRating] = useState<number | null>(null)

    useEffect(() => {
        setRating(book.rating ?? 1)
    }, [book]);

    const updateRatingToServer = () => {
        BooksitoutServer
            .put(`/v1/book/${book.id}`, {rating: rating})
            .then(() => {
                onClose()
                updateRating(rating)

                if (book.rating == null) {
                    toast.success(`책에 평점을 추가했어요.`);
                } else {
                    toast.success(`책의 평점을 수정했어요.`);
                }
            })
            .catch(() => toast.error(`오류가 났어요. 잠시 후 다시 시도해 주세요.`))
    }

    const displayRating = hoverRating ?? rating

    return (
        <Modal titleText={book.rating == null ? `평점 추가하기` : `평점 수정하기`} isShowing={isModalOpen} onClose={onClose} body={
            <Container>
                <RowSpacer size={10}/>

                <RatingText>{displayRating}점</RatingText>

                <RowSpacer size={5}/>

                <StarContainer onMouseLeave={() => setHoverRating(null)}>
                    {[1, 2, 3, 4, 5].map((i) => (
                        <RatingStar
                            key={i}
                            isFilled={displayRating >= i}
                            size={50}
                            isInteractive={true}
                            onClick={() => setRating(i)}
                            onMouseEnter={() => setHoverRating(i)}
                        />
                    ))}
                </StarContainer>

                <BottomCTA message={'평점 추가하기'} onClick={updateRatingToServer}/>
            </Container>
        }/>
    )
}

const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
`

const StarContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
`

const RatingText = styled.span`
    font-size: 24px;
    font-weight: bold;
    color: var(--text-color);
`

export default BookRatingModal
